import context, { getDefaultState } from 'chimera/all/store/context'
import deepmerge from 'deepmerge'

export const state = () => {
  return deepmerge(getDefaultState(), {
    country: 'nl',
    language: 'nl',
  })
}

export default {
  ...context,
  state,
}
